import React from "react";
import _ from "lodash";

import withStyles from '@material-ui/core/styles/withStyles';
import Grid from "@material-ui/core/Grid";

import styles from "./styles";

const GroupFilterResult = ({filters, count, classes}) => {
  const filterResult = React.useMemo(() => {
    let searchText = filters.first_letter ? `Anfangszeichen ${filters.first_letter}` : filters.search;

    let filterBy = [];

    if (searchText){
      filterBy.push(<>Gruppe <span className={'word'}>“{searchText}”</span></>)
    }

    const selectedCustomers = (filters.customers || []);
    if(!_.isEmpty(selectedCustomers)){
      filterBy.push(<>Kunde <span className={'word'}>“{_.join(_.map(selectedCustomers, 'name'), ', ')}”</span></>)
    }

    return filterBy;
  }, [filters]);

  return (
    <Grid className={classes.topMessage} item xs={12}>
      {!_.isEmpty(filterResult) && (
        <>
          Ihre Suche nach&nbsp;
          {filterResult.map((line, idx) => (
            <>
              {idx > 0 && ', '}
              {line}
            </>
          ))}
          &nbsp;({count || 'Keine'} Ergebnisse).
        </>
      )}
    </Grid>
  )
};

export default withStyles(styles)(GroupFilterResult);